import { map } from "rxjs";
import { LinkedAccount } from "../../model";
import apiService from "../ApiService";

// Back-end documentation is lying: API can return null linkedAccounts
export const getLinkedAccounts = () => {
  return apiService
    .get<{ linkedAccounts: LinkedAccount[] }>({
      path: `public/account/linked_accounts`,
      crm: true,
    })
    .pipe(map((e) => e.linkedAccounts || []));
};
